import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { SET_IS_CURATION_ENABLED_ALLERGEN_MUTATION } from '../graphql/mutations'
import { SET_IS_CURATION_ENABLED_ALLERGEN } from '../redux/action-types'

const useSetIsCurationEnabledAllergenMutation = refetchLastEvent => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(store => store.allergens.allergens)

  const mutate = useCallback(
    async (id, isCurationEnabled) => {
      await apolloService.mutate(
        SET_IS_CURATION_ENABLED_ALLERGEN_MUTATION,
        {
          id,
          isCurationEnabled,
        },
        dispatch,
        SET_IS_CURATION_ENABLED_ALLERGEN,
      )

      refetchLastEvent()
    },
    [dispatch, refetchLastEvent],
  )

  return [mutate, { isLoading, error }]
}

export default useSetIsCurationEnabledAllergenMutation
